import { LoginRequestBody } from '@types';
import { buildQueryString } from '@utils/helpers';
import { lmsRequest } from './lmsRequest';

export const getS3SignedDownloadUrl = (filename: string, mediaType: string, msgOptions?: MsgOptions): Promise<any> =>
  lmsRequest(`/s3/sign/download`).auth().post().body({ filename, type: mediaType }, true).send(msgOptions);

export const getCloudinarySignedDownloadUrl = async (
  publicId: string,
  type: string,
  msgOptions?: MsgOptions
): Promise<any> => {
  const res: any = await lmsRequest('/cloudinary/sign/download')
    .auth()
    .post()
    .body({ publicId, type }, true)
    .send({ ...msgOptions, errorMsg: 'Error getting Cloudinary signed url' });
  const { signedUrl } = res.data;
  if (!signedUrl && msgOptions?.enqueueSnackbar) {
    msgOptions.enqueueSnackbar('Error getting Cloudinary signed url', { variant: 'error' });
  }

  return signedUrl;
};

export const getResourceUrl = (urlOrPublicId: string, type: string, msgOptions?: MsgOptions): any => {
  return urlOrPublicId.slice(0, 4) !== 'http'
    ? getCloudinarySignedDownloadUrl(urlOrPublicId, type, msgOptions)
    : Promise.resolve(urlOrPublicId);
};

export const getRole = (email: string, tenant_id: uuid, msgOptions?: MsgOptions): Promise<any> =>
  lmsRequest(buildQueryString('/role', { email, tenant_id })).send(msgOptions);

export const apiUser = {
  get: {
    self: (token?: string, msgOptions?: MsgOptions) => lmsRequest<User>('/me').auth(token).send(msgOptions),
  },

  update: (data: Partial<User>, msgOptions?: MsgOptions) =>
    lmsRequest<User>('/me').put().body(data, true).auth().send(msgOptions),

  login: (data: LoginRequestBody, msgOptions: MsgOptions) =>
    lmsRequest<any>('/login').post().body(data, true).send(msgOptions),
};

export const confirmInvite = (token: uuid, msgOptions?: MsgOptions) =>
  lmsRequest(`/confirm?token=${token}`).send(msgOptions);

export const apiUrl = {
  get: {
    single: (code: string, token: string, subdomain: string = '', msgOptions?: MsgOptions) => {
      const query = { subdomain, code };
      return token
        ? lmsRequest<any>(buildQueryString('/url/private', query)).auth(token).send(msgOptions)
        : lmsRequest<any>(buildQueryString('/url/public', query)).send(msgOptions);
    },

    openUrl: (query: { subdomain: string; code: string }, msgOptions?: MsgOptions) =>
      lmsRequest<Url>(buildQueryString('/invite-url', query)).send(msgOptions),
  },
};

export const apiInvite = {
  get: {
    student: (inviteToken: string, msgOptions?: MsgOptions) =>
      lmsRequest<any>(buildQueryString('/tenant/enrolled-student/invite-info', { inviteToken })).send(msgOptions),
  },
};
